import React, { ChangeEvent, useCallback } from "react"
import { VsOption } from "@ssc-booking/api-contracts"
import { Icon, InputCheckbox } from "@silversea-ssc/ui-components-react"
import { Trans } from "@lingui/macro"
import styles from "./VsCheckbox.module.scss"

type Props = {
    vsOption: VsOption
    value: boolean
    onChange: (vsMember: boolean) => void
}

const VsCheckbox: React.FC<React.PropsWithChildren<Props>> = ({ value, vsOption, onChange }) => {
    const innerOnChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
        [onChange],
    )
    return (
        <div data-content-name="vs-checkbox" className={styles.checkboxContainer}>
            <label className={styles.optionLabel}>
                <Icon name="venetian-society-saving" size={"1.5x"} className={styles.icon} padding={"inline"} />
                {vsOption.percentage}% <Trans>Venetian Society saving</Trans>
            </label>
            <InputCheckbox
                containerClassName={styles.checkbox}
                checked={value}
                position="Left"
                value="true"
                id="vs"
                width="auto"
                onChange={innerOnChange}
            >
                <Trans>I’ve travelled with Silversea before</Trans>
            </InputCheckbox>
            <div className={styles.inputTipInfo}>
                <Trans>Please note that this saving is not applicable to all the All-inclusive fare</Trans>
            </div>
        </div>
    )
}

export default VsCheckbox
